import { render, staticRenderFns } from "./Npi.vue?vue&type=template&id=257d5866&scoped=true"
import script from "./Npi.vue?vue&type=script&lang=js"
export * from "./Npi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d5866",
  null
  
)

export default component.exports